<template>
    <div class="jetlympic-home">
       <div class="header">
            <img src="@/assets/jetlympic/logo.png" />
       </div>
       <div class="switch">
           中文 <van-switch style="margin: 0 12px;" size="24" v-model="checked" active-color="#fff" inactive-color="#FFFFFF" @change="switchLanguage" /> EN
       </div>
       <div class="content">
        <div class="item" v-for="item in list" :key="item.id" @click="handleItemClick(item)">
            <img :src="item.icon" />
            <div class="title" :style="{'font-size': checked ? '14px' : '16px'}">{{ $t(`jetlympic.home.${item.id}`) }}</div>
        </div>
       </div>
       <div class="footer">POWER BY BMBsports</div>
        <img class="banner" src="@/assets/jetlympic/banner.png" />
    </div>
</template>

<script>
import Vue from 'vue';
import { Switch } from 'vant';
import { getToken } from '@/libs/cookie-storage';
Vue.use(Switch);
export default {
    data() {
        return {
            checked: this.$i18n.locale === 'en', // 根据当前语言设置开关状态
            list: [
                {
                    id: 'home_item_1',
                    path: '/jetlympic/video?type=mini',
                    icon: require('@/assets/jetlympic/home_item_1.png'),
                },
                {
                    id: 'home_item_2',
                    path: '/jetlympic/hotel?type=hotel',
                    icon: require('@/assets/jetlympic/home_item_2.png'),
                },
                {
                    id: 'home_item_3',
                    path: '/jetlympic/schedule',
                    accountId: {
                        zh: '94669',
                        en: '94793',
                    },
                    icon: require('@/assets/jetlympic/home_item_3.png'),
                },
                {
                    id: 'home_item_4',
                    path: '/jetlympic/shuttle',
                    icon: require('@/assets/jetlympic/home_item_4.png'),
                },
                {
                    id: 'home_item_5',
                    path: '/jetlympic/live-matches',
                    accountId: {
                        zh: '94669',
                        en: '94793',
                    },
                    icon: require('@/assets/jetlympic/home_item_5.png'),
                },
                {
                    id: 'home_item_6',
                    icon: require('@/assets/jetlympic/home_item_6.png'),
                    path: '/jetlympic/list?type=image',
                },
                {
                    id: 'home_item_7',
                    icon: require('@/assets/jetlympic/home_item_7.png'),
                    path: '/jetlympic/list?type=regulations',
                },
                {
                    id: 'home_item_8',
                    icon: require('@/assets/jetlympic/home_item_8.png'),
                    path: '/account/news-list/94669'
                },
                {
                    id: 'home_item_9',
                    path: '/jetlympic/list?type=data',
                    icon: require('@/assets/jetlympic/home_item_9.png'),
                }
            ]
        };
    },
    mounted() {
        window.localStorage.setItem('jetlympic', 'jetlympic');
    },
    methods: {
        switchLanguage(value) {
            // value为true时切换到英文，false时切换到中文
            const language = value ? 'en' : 'zh';
            this.$i18n.locale = language;
            localStorage.setItem('language', language);
        },
        handleItemClick(item) {
            if(item.path.includes('http')){
                window.location.href = item.path;
                return
            }
            const passport = getToken()
            if (passport) {
                if(!item.path){
                    this.$toast('功能暂未上线，敬请期待 \n This feature is not yet \n available. ');
                    return
                }
                if(item.accountId){
                    this.$router.push({ path: item.path, query: { accountId: item.accountId[this.$i18n.locale] } });
                } else {
                    this.$router.push({ path: item.path });
                }
            } else {
                let redirect = window.location.hash
                redirect = redirect.substring(1)
                this.$router.push({ path: `/jetlympic/login?redirect=${encodeURIComponent(redirect)}` });
            }
        }
    },
};
</script>

<style scoped lang="scss">
.jetlympic-home{
    padding: 0 18px;
    width: 100%;
    height: 100vh;
    background-color: #00A7FF;
    box-sizing: border-box;
    overflow-y: auto;
    padding-bottom: 18px;
    .header{
        text-align: center;
        padding-top: 14px;
        img{
            width: 240px;
        }
    }
    .banner{
      position: fixed;
      bottom: 0px;
      left: 0px;
      width: 100%;
      opacity: 0.6;
      z-index: 1;
    }
    .switch{
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        color: #fff;
        font-size: 20px;
        font-weight: 500;
        margin-top: 14px;
    }
    .content{
        position: relative;
        z-index: 3;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 18px;
        .item{
            width: 109px;
            height: 122px;
            border-radius: 12px;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-bottom: 6px;
            img{
                width: 55px;
                height: 55px;
            }
            .title{
                height: 35px;
                font-size: 16px;
                color: #00A7FF;
                margin-top: 12px;
                padding: 0 12px;
                text-align: center;
            }
        }
    }
    .footer{
        text-align: center;
        color: rgba(255, 255, 255, 0.4);
        font-size: 13px;
        margin-top: 18px;
    }
}
:deep(.van-switch__node){
  background-color: #00A7FF;
}
</style>
